import { render, staticRenderFns } from "./SyncMainModal.vue?vue&type=template&id=ed79bdac&lang=pug"
import script from "./SyncMainModal.vue?vue&type=script&lang=js"
export * from "./SyncMainModal.vue?vue&type=script&lang=js"
import style0 from "./SyncMainModal.vue?vue&type=style&index=0&id=ed79bdac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports